{
  "agentModelSorts": [
    {
      "displayName": "Recommended",
      "groups": [
        {
          "modelIds": [
            "gemini-3.8-flash-high",
            "gemini-3.8-flash-medium",
            "gemini-3.8-flash-low",
            "claude-opus-5-5-low",
            "claude-opus-5-5-medium",
            "claude-opus-5-5-high",
            "claude-sonnet-5-5-low",
            "claude-sonnet-5-5-medium",
            "claude-sonnet-5-5-high",
            "gpt-oss-120b-medium"
          ]
        }
      ]
    }
  ],
  "audioTranscriptionModelIds": [
    "models/proactive-observer-v10"
  ],
  "commandModelIds": [
    "gemini-3-flash"
  ],
  "commitMessageModelIds": [
    "gemini-3.5-flash-lite"
  ],
  "defaultAgentModelId": "gemini-3.8-flash-high",
  "experimentIds": [
    106826239,
    106828853,
    106827293,
    106826316,
    106828852,
    106827294,
    106791760,
    106786387,
    106791766,
    106828854,
    106427252,
    106815069,
    106805876,
    105979552,
    105979574,
    106015333,
    106568772,
    105867471,
    106749606,
    106123599,
    106121401,
    106100625,
    106754391,
    106143956,
    105856899,
    106064030,
    106544525,
    106021688,
    105887299,
    106428370,
    106640126,
    106793266,
    106380926,
    106281951,
    106264532,
    106032303,
    106228452,
    106121607,
    106793059,
    105979531,
    105979553,
    106015328,
    106568390,
    105867469,
    106123597,
    106121399,
    106100654,
    106064028,
    105906495,
    106640124,
    106032301,
    106121604,
    106793057,
    106778026,
    106786388
  ],
  "imageGenerationModelIds": [
    "gemini-3.1-flash-image"
  ],
  "models": {
    "chat_20706": {
      "addCursorToFindReplaceTarget": true,
      "apiProvider": "API_PROVIDER_INTERNAL",
      "isInternal": true,
      "maxTokens": 16384,
      "model": "MODEL_CHAT_20706",
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "promptTemplaterType": "PROMPT_TEMPLATER_TYPE_CHATML",
      "quotaInfo": {
        "remainingFraction": 1
      },
      "requiresLeadInGeneration": true,
      "supportsCumulativeContext": true,
      "supportsEstimateTokenCounter": true,
      "tabJumpPrintLineRange": true,
      "toolFormatterType": "TOOL_FORMATTER_TYPE_XML"
    },
    "chat_23310": {
      "apiProvider": "API_PROVIDER_INTERNAL",
      "isInternal": true,
      "maxTokens": 32768,
      "model": "MODEL_CHAT_23310",
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "promptTemplaterType": "PROMPT_TEMPLATER_TYPE_CHATML",
      "quotaInfo": {
        "remainingFraction": 1
      },
      "requiresLeadInGeneration": true,
      "supportsCumulativeContext": true,
      "supportsEstimateTokenCounter": true,
      "toolFormatterType": "TOOL_FORMATTER_TYPE_XML"
    },
    "claude-opus-5-5-high": {
      "apiProvider": "API_PROVIDER_ANTHROPIC_VERTEX",
      "displayName": "Claude Opus 5.5 (High)",
      "maxOutputTokens": 128000,
      "maxTokens": 1000000,
      "model": "MODEL_PLACEHOLDER_M402",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_ANTHROPIC",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "video/jpeg2000": true,
        "video/videoframe/jpeg2000": true
      },
      "supportsAdaptiveThinking": true,
      "supportsImages": true,
      "supportsThinking": true,
      "tagTitle": "New",
      "thinkingLevel": 3,
      "vertexModelId": "claude-opus-5-5@default"
    },
    "claude-opus-5-5-low": {
      "apiProvider": "API_PROVIDER_ANTHROPIC_VERTEX",
      "displayName": "Claude Opus 5.5 (Low)",
      "maxOutputTokens": 128000,
      "maxTokens": 1000000,
      "model": "MODEL_PLACEHOLDER_M400",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_ANTHROPIC",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "video/jpeg2000": true,
        "video/videoframe/jpeg2000": true
      },
      "supportsAdaptiveThinking": true,
      "supportsImages": true,
      "supportsThinking": true,
      "tagTitle": "New",
      "thinkingLevel": 1,
      "vertexModelId": "claude-opus-5-5@default"
    },
    "claude-opus-5-5-medium": {
      "apiProvider": "API_PROVIDER_ANTHROPIC_VERTEX",
      "displayName": "Claude Opus 5.5 (Medium)",
      "maxOutputTokens": 128000,
      "maxTokens": 1000000,
      "model": "MODEL_PLACEHOLDER_M401",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_ANTHROPIC",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "video/jpeg2000": true,
        "video/videoframe/jpeg2000": true
      },
      "supportsAdaptiveThinking": true,
      "supportsImages": true,
      "supportsThinking": true,
      "tagTitle": "New",
      "thinkingLevel": 2,
      "vertexModelId": "claude-opus-5-5@default"
    },
    "claude-sonnet-5-5-high": {
      "apiProvider": "API_PROVIDER_ANTHROPIC_VERTEX",
      "displayName": "Claude Sonnet 5.5 (High)",
      "maxOutputTokens": 128000,
      "maxTokens": 1000000,
      "model": "MODEL_PLACEHOLDER_M405",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_ANTHROPIC",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "video/jpeg2000": true,
        "video/videoframe/jpeg2000": true
      },
      "supportsAdaptiveThinking": true,
      "supportsImages": true,
      "supportsThinking": true,
      "tagTitle": "New",
      "thinkingLevel": 3,
      "vertexModelId": "claude-sonnet-5-5@default"
    },
    "claude-sonnet-5-5-low": {
      "apiProvider": "API_PROVIDER_ANTHROPIC_VERTEX",
      "displayName": "Claude Sonnet 5.5 (Low)",
      "maxOutputTokens": 128000,
      "maxTokens": 1000000,
      "model": "MODEL_PLACEHOLDER_M403",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_ANTHROPIC",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "video/jpeg2000": true,
        "video/videoframe/jpeg2000": true
      },
      "supportsAdaptiveThinking": true,
      "supportsImages": true,
      "supportsThinking": true,
      "tagTitle": "New",
      "thinkingLevel": 1,
      "vertexModelId": "claude-sonnet-5-5@default"
    },
    "claude-sonnet-5-5-medium": {
      "apiProvider": "API_PROVIDER_ANTHROPIC_VERTEX",
      "displayName": "Claude Sonnet 5.5 (Medium)",
      "maxOutputTokens": 128000,
      "maxTokens": 1000000,
      "model": "MODEL_PLACEHOLDER_M404",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_ANTHROPIC",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "video/jpeg2000": true,
        "video/videoframe/jpeg2000": true
      },
      "supportsAdaptiveThinking": true,
      "supportsImages": true,
      "supportsThinking": true,
      "tagTitle": "New",
      "thinkingLevel": 2,
      "vertexModelId": "claude-sonnet-5-5@default"
    },
    "gemini-2.5-flash": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash Lite",
      "maxOutputTokens": 65535,
      "maxTokens": 1048576,
      "minThinkingBudget": 128,
      "model": "MODEL_GOOGLE_GEMINI_2_5_FLASH",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "tagDescription": "gemini-3.5-flash-lite",
      "thinkingBudget": -1,
      "thinkingLevel": 1
    },
    "gemini-2.5-flash-lite": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash Lite",
      "maxOutputTokens": 65535,
      "maxTokens": 1048576,
      "minThinkingBudget": 128,
      "model": "MODEL_GOOGLE_GEMINI_2_5_FLASH_LITE",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "tagDescription": "gemini-3.5-flash-lite",
      "thinkingBudget": -1,
      "thinkingLevel": 1
    },
    "gemini-2.5-flash-thinking": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash Lite",
      "maxOutputTokens": 65535,
      "maxTokens": 1048576,
      "minThinkingBudget": 128,
      "model": "MODEL_GOOGLE_GEMINI_2_5_FLASH_THINKING",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "tagDescription": "gemini-3.5-flash-lite",
      "thinkingBudget": -1,
      "thinkingLevel": 1
    },
    "gemini-2.5-pro": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 2.5 Pro",
      "maxOutputTokens": 65535,
      "maxTokens": 1048576,
      "minThinkingBudget": 128,
      "model": "MODEL_GOOGLE_GEMINI_2_5_PRO",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "requiresImageOutputOutsideFunctionResponses": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "thinkingBudget": 1024
    },
    "gemini-3-flash": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3 Flash",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M18",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": -1
    },
    "gemini-3-flash-agent": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash (High)",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M84",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "template__system_prompts__planning_mode_artifacts": {
            "stringValue": "When in planning mode, you will work with three special artifacts.\n\n# Tasks\nPath: {{ArtifactDirectoryPath}}/task.md\n\n**Purpose**: A TODO list to organize your work during execution. Create this artifact after receiving user approval on your implementation plan. Break down complex tasks into component-level items and track progress as a living document.\n\n**Format**:\n```markdown\n- `[ ]` uncompleted tasks\n- `[/]` in progress tasks (custom notation)\n- `[x]` completed tasks\n- Use indented lists for sub-items\n```\n\n**Updating task.md**: Mark items as `[/]` when starting work on them, and `[x]` when completed. Update task.md as you make progress through your checklist.\n\n# Implementation Plan\nPath: {{ArtifactDirectoryPath}}/implementation_plan.md\n\n**Purpose**: A detailed design document to present your technical implementation plan to the user for feedback and approval.\nAfter reading the document, the user should understand the key technical details of your plan, and be able to make an informed decision on whether to approve it.\n\n**Format**: Use the following format, omitting any irrelevant sections.\n```markdown\n# [Goal Description]\n\nProvide a brief description of the problem, any background context, and what the change accomplishes.\n\n## User Review Required\n\nDocument anything that requires user review or feedback, for example, breaking changes or significant design decisions. Use GitHub alerts (IMPORTANT/WARNING/CAUTION) to highlight critical items.\n\n## Open Questions\n\nAny clarifying or design questions for the user that will impact the implementation plan. Use GitHub alerts (IMPORTANT/WARNING/CAUTION) to highlight critical items.\n\n## Proposed Changes\n\nGroup files by component (e.g., package, feature area, dependency layer) and order logically (dependencies first). Separate components with horizontal rules for visual clarity.\n\n### [Component Name]\n\nSummary of what will change in this component, separated by files. For specific files, Use [NEW] and [DELETE] to demarcate new and deleted files, for example:\n\n#### [MODIFY] [file basename](file:///absolute/path/to/modifiedfile)\n#### [NEW] [file basename](file:///absolute/path/to/newfile)\n#### [DELETE] [file basename](file:///absolute/path/to/deletedfile)\n\n## Verification Plan\n\nSummary of how you will verify that your changes have the desired effects.\n\n### Automated Tests\n- The commands of any automated tests you'll run.\n\n### Manual Verification\n- Asking the user to deploy to staging and testing, verifying UI changes on an iOS app etc.\n```\n\n# Walkthrough\nPath: {{ArtifactDirectoryPath}}/walkthrough.md\n\n**Purpose**: After completing work, summarize what you accomplished. Update an existing walkthrough for related follow-up work rather than creating a new one.\n\n**Document**:\n- Changes made\n- What was tested\n- Validation results\n\nEmbed screenshots and recordings to visually demonstrate UI changes and user flows.\n"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": -1
    },
    "gemini-3.1-flash-image": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.1 Flash Image",
      "model": "MODEL_PLACEHOLDER_M21",
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      }
    },
    "gemini-3.1-flash-lite": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.1 Flash Lite",
      "maxOutputTokens": 65535,
      "maxTokens": 1048576,
      "model": "MODEL_PLACEHOLDER_M50",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      }
    },
    "gemini-3.5-flash-extra-low": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash (Low)",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M187",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "template__system_prompts__planning_mode_artifacts": {
            "stringValue": "When in planning mode, you will work with three special artifacts.\n\n# Tasks\nPath: {{ArtifactDirectoryPath}}/task.md\n\n**Purpose**: A TODO list to organize your work during execution. Create this artifact after receiving user approval on your implementation plan. Break down complex tasks into component-level items and track progress as a living document.\n\n**Format**:\n```markdown\n- `[ ]` uncompleted tasks\n- `[/]` in progress tasks (custom notation)\n- `[x]` completed tasks\n- Use indented lists for sub-items\n```\n\n**Updating task.md**: Mark items as `[/]` when starting work on them, and `[x]` when completed. Update task.md as you make progress through your checklist.\n\n# Implementation Plan\nPath: {{ArtifactDirectoryPath}}/implementation_plan.md\n\n**Purpose**: A detailed design document to present your technical implementation plan to the user for feedback and approval.\nAfter reading the document, the user should understand the key technical details of your plan, and be able to make an informed decision on whether to approve it.\n\n**Format**: Use the following format, omitting any irrelevant sections.\n```markdown\n# [Goal Description]\n\nProvide a brief description of the problem, any background context, and what the change accomplishes.\n\n## User Review Required\n\nDocument anything that requires user review or feedback, for example, breaking changes or significant design decisions. Use GitHub alerts (IMPORTANT/WARNING/CAUTION) to highlight critical items.\n\n## Open Questions\n\nAny clarifying or design questions for the user that will impact the implementation plan. Use GitHub alerts (IMPORTANT/WARNING/CAUTION) to highlight critical items.\n\n## Proposed Changes\n\nGroup files by component (e.g., package, feature area, dependency layer) and order logically (dependencies first). Separate components with horizontal rules for visual clarity.\n\n### [Component Name]\n\nSummary of what will change in this component, separated by files. For specific files, Use [NEW] and [DELETE] to demarcate new and deleted files, for example:\n\n#### [MODIFY] [file basename](file:///absolute/path/to/modifiedfile)\n#### [NEW] [file basename](file:///absolute/path/to/newfile)\n#### [DELETE] [file basename](file:///absolute/path/to/deletedfile)\n\n## Verification Plan\n\nSummary of how you will verify that your changes have the desired effects.\n\n### Automated Tests\n- The commands of any automated tests you'll run.\n\n### Manual Verification\n- Asking the user to deploy to staging and testing, verifying UI changes on an iOS app etc.\n```\n\n# Walkthrough\nPath: {{ArtifactDirectoryPath}}/walkthrough.md\n\n**Purpose**: After completing work, summarize what you accomplished. Update an existing walkthrough for related follow-up work rather than creating a new one.\n\n**Document**:\n- Changes made\n- What was tested\n- Validation results\n\nEmbed screenshots and recordings to visually demonstrate UI changes and user flows.\n"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": 1000
    },
    "gemini-3.5-flash-lite": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash Lite",
      "maxOutputTokens": 65535,
      "maxTokens": 1048576,
      "minThinkingBudget": 128,
      "model": "MODEL_PLACEHOLDER_M198",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SINGLE_PROMPT\",\n    \"max_token_limit\": \"128000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "tagDescription": "gemini-3.5-flash-lite",
      "thinkingBudget": -1,
      "thinkingLevel": 1
    },
    "gemini-3.5-flash-low": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.5 Flash (Medium)",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M20",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "template__system_prompts__planning_mode_artifacts": {
            "stringValue": "When in planning mode, you will work with three special artifacts.\n\n# Tasks\nPath: {{ArtifactDirectoryPath}}/task.md\n\n**Purpose**: A TODO list to organize your work during execution. Create this artifact after receiving user approval on your implementation plan. Break down complex tasks into component-level items and track progress as a living document.\n\n**Format**:\n```markdown\n- `[ ]` uncompleted tasks\n- `[/]` in progress tasks (custom notation)\n- `[x]` completed tasks\n- Use indented lists for sub-items\n```\n\n**Updating task.md**: Mark items as `[/]` when starting work on them, and `[x]` when completed. Update task.md as you make progress through your checklist.\n\n# Implementation Plan\nPath: {{ArtifactDirectoryPath}}/implementation_plan.md\n\n**Purpose**: A detailed design document to present your technical implementation plan to the user for feedback and approval.\nAfter reading the document, the user should understand the key technical details of your plan, and be able to make an informed decision on whether to approve it.\n\n**Format**: Use the following format, omitting any irrelevant sections.\n```markdown\n# [Goal Description]\n\nProvide a brief description of the problem, any background context, and what the change accomplishes.\n\n## User Review Required\n\nDocument anything that requires user review or feedback, for example, breaking changes or significant design decisions. Use GitHub alerts (IMPORTANT/WARNING/CAUTION) to highlight critical items.\n\n## Open Questions\n\nAny clarifying or design questions for the user that will impact the implementation plan. Use GitHub alerts (IMPORTANT/WARNING/CAUTION) to highlight critical items.\n\n## Proposed Changes\n\nGroup files by component (e.g., package, feature area, dependency layer) and order logically (dependencies first). Separate components with horizontal rules for visual clarity.\n\n### [Component Name]\n\nSummary of what will change in this component, separated by files. For specific files, Use [NEW] and [DELETE] to demarcate new and deleted files, for example:\n\n#### [MODIFY] [file basename](file:///absolute/path/to/modifiedfile)\n#### [NEW] [file basename](file:///absolute/path/to/newfile)\n#### [DELETE] [file basename](file:///absolute/path/to/deletedfile)\n\n## Verification Plan\n\nSummary of how you will verify that your changes have the desired effects.\n\n### Automated Tests\n- The commands of any automated tests you'll run.\n\n### Manual Verification\n- Asking the user to deploy to staging and testing, verifying UI changes on an iOS app etc.\n```\n\n# Walkthrough\nPath: {{ArtifactDirectoryPath}}/walkthrough.md\n\n**Purpose**: After completing work, summarize what you accomplished. Update an existing walkthrough for related follow-up work rather than creating a new one.\n\n**Document**:\n- Changes made\n- What was tested\n- Validation results\n\nEmbed screenshots and recordings to visually demonstrate UI changes and user flows.\n"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": 4000
    },
    "gemini-3.8-flash-high": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.8 Flash (High)",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M318",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "cascade-include-ephemeral-message": {
            "stringValue": "{\n    \"enabled\": false,\n    \"disabledHeuristics\": [\"planning_mode\", \"bash_command_reminder\", \"running_tasks_reminder\"],\n    \"staticMessages\": [],\n    \"useAllowlist\": false,\n    \"enabledHeuristics\": []\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          },
          "task-details-suffix": {
            "stringValue": "\nYOU MUST TAKE ONE OF THE FOLLOWING TWO ACTIONS: A) either proceed to other relevant work (if any) or, B) simply update the user with a short message (that you have launched the command and will wait for it to finish) and end the turn.\n DO NOTHING ELSE."
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": -1
    },
    "gemini-3.8-flash-low": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.8 Flash (Low)",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M320",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "cascade-include-ephemeral-message": {
            "stringValue": "{\n    \"enabled\": false,\n    \"disabledHeuristics\": [\"planning_mode\", \"bash_command_reminder\", \"running_tasks_reminder\"],\n    \"staticMessages\": [],\n    \"useAllowlist\": false,\n    \"enabledHeuristics\": []\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          },
          "task-details-suffix": {
            "stringValue": "\nYOU MUST TAKE ONE OF THE FOLLOWING TWO ACTIONS: A) either proceed to other relevant work (if any) or, B) simply update the user with a short message (that you have launched the command and will wait for it to finish) and end the turn.\n DO NOTHING ELSE."
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": 1000
    },
    "gemini-3.8-flash-medium": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "displayName": "Gemini 3.8 Flash (Medium)",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M319",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "cascade-include-ephemeral-message": {
            "stringValue": "{\n    \"enabled\": false,\n    \"disabledHeuristics\": [\"planning_mode\", \"bash_command_reminder\", \"running_tasks_reminder\"],\n    \"staticMessages\": [],\n    \"useAllowlist\": false,\n    \"enabledHeuristics\": []\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          },
          "task-details-suffix": {
            "stringValue": "\nYOU MUST TAKE ONE OF THE FOLLOWING TWO ACTIONS: A) either proceed to other relevant work (if any) or, B) simply update the user with a short message (that you have launched the command and will wait for it to finish) and end the turn.\n DO NOTHING ELSE."
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": 4000
    },
    "gemini-3.8-flash-tiered": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "maxOutputTokens": 65536,
      "maxTokens": 1048576,
      "minThinkingBudget": 32,
      "model": "MODEL_PLACEHOLDER_M322",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_SAME_MODEL\",\n    \"max_token_limit\": \"256000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"16384\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": true,\n    \"is_sync\": true,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": true,\n    \"include_conversation_log\": false,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 4,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"You have been working on the task described above but have not yet completed\\nit. Write a continuation summary that will allow you (or another instance of\\nyourself) to resume work efficiently in a future context window where the\\nfull conversation history will NOT be available\\u2014only this summary.\\n\\nThis summary is all that will be available to you going forward in the future\\ncontext window. Do not call any tools, simply just provide the summary based on\\nthe information available in the current context window.\\n\\nYour summary must be structured, concise, and actionable. Optimize for enabling immediate resumption with zero redundant work.\\n\\nInclude the following sections:\\n\\n1. **Task Overview**\\n   - The user's core request and success criteria\\n   - Constraints, preferences, or scope boundaries they specified\\n   - Any ambiguities that were resolved (and how)\\n\\n2. **Progress**\\n   - What has been completed, with concrete references (file paths,\\n     resource identifiers, tool outputs, URLs, etc.)\\n   - Key artifacts produced and their current state\\n   - What is in progress but incomplete, and its current state\\n\\n3. **Key Findings**\\n   - Technical constraints, requirements, or domain details uncovered\\n   - Decisions made and their rationale\\n   - Errors encountered and their resolutions\\n   - Approaches that were tried and abandoned (and why\\u2014this prevents\\n     the successor from repeating them)\\n\\n4. **Active Context**\\n   - State of any external resources, sessions, or environments in use\\n   - Relevant intermediate results, hypotheses, or working assumptions\\n   - Dependencies between components or steps\\n\\n5. **Next Steps**\\n   - Specific actions needed to complete the task, in priority order\\n   - Known blockers or open questions that must be resolved\\n   - For each step, note any prerequisites or risks\\n\\n6. **Commitments & Constraints**\\n   - Promises made to the user (e.g., \\\"I said I would do X before Y\\\")\\n   - User preferences or style requirements\\n   - Any boundaries the user set on approach, tools, or scope\\n\\nBe concise but complete\\u2014err on the side of including anything that would\\nprevent duplicate work, repeated mistakes, or broken promises. Do not include\\ninformation that is obvious from the task description itself.\\n\\nWrap your response in <summary></summary> tags.\\n\",\n    \"use_model_reported_token_count\": false\n}"
          },
          "cascade-include-ephemeral-message": {
            "stringValue": "{\n    \"enabled\": false,\n    \"disabledHeuristics\": [\"planning_mode\", \"bash_command_reminder\", \"running_tasks_reminder\"],\n    \"staticMessages\": [],\n    \"useAllowlist\": false,\n    \"enabledHeuristics\": []\n}"
          },
          "retry_model_capacity_exhausted": {
            "boolValue": true
          },
          "task-details-suffix": {
            "stringValue": "\nYOU MUST TAKE ONE OF THE FOLLOWING TWO ACTIONS: A) either proceed to other relevant work (if any) or, B) simply update the user with a short message (that you have launched the command and will wait for it to finish) and end the turn.\n DO NOTHING ELSE."
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 0.9750844,
        "resetTime": "2026-10-13T11:45:39Z"
      },
      "recommended": true,
      "supportedMimeTypes": {
        "application/json": true,
        "application/msword": true,
        "application/pdf": true,
        "application/rtf": true,
        "application/vnd.ms-excel": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/x-ipynb+json": true,
        "application/x-javascript": true,
        "application/x-python-code": true,
        "application/x-typescript": true,
        "audio/aac": true,
        "audio/flac": true,
        "audio/l16": true,
        "audio/m4a": true,
        "audio/mp3": true,
        "audio/mp4": true,
        "audio/mpeg": true,
        "audio/ogg": true,
        "audio/opus": true,
        "audio/vnd.wave": true,
        "audio/wav": true,
        "audio/wave": true,
        "audio/webm": true,
        "audio/webm;codecs=opus": true,
        "audio/x-wav": true,
        "image/heic": true,
        "image/heif": true,
        "image/jpeg": true,
        "image/png": true,
        "image/webp": true,
        "text/css": true,
        "text/csv": true,
        "text/html": true,
        "text/javascript": true,
        "text/markdown": true,
        "text/plain": true,
        "text/rtf": true,
        "text/x-python": true,
        "text/x-python-script": true,
        "text/x-typescript": true,
        "text/xml": true,
        "video/audio/s16le": true,
        "video/audio/wav": true,
        "video/jpeg2000": true,
        "video/mp4": true,
        "video/text/timestamp": true,
        "video/videoframe/jpeg2000": true,
        "video/webm": true
      },
      "supportsImages": true,
      "supportsThinking": true,
      "supportsVideo": true,
      "thinkingBudget": -1
    },
    "gpt-oss-120b-medium": {
      "apiProvider": "API_PROVIDER_OPENAI_VERTEX",
      "displayName": "GPT-OSS 120B (Medium)",
      "maxOutputTokens": 32768,
      "maxTokens": 131072,
      "model": "MODEL_OPENAI_GPT_OSS_120B_MEDIUM",
      "modelExperiments": {
        "experiments": {
          "CASCADE_USE_EXPERIMENT_CHECKPOINTER": {
            "stringValue": "{\n    \"strategy\": \"CHECKPOINT_STRATEGY_UNSPECIFIED\",\n    \"max_token_limit\": \"80000\",\n    \"token_threshold\": \"50000\",\n    \"max_overhead_ratio\": \"0.15\",\n    \"moving_window_size\": \"1\",\n    \"enabled\": true,\n    \"max_output_tokens\": \"8192\",\n    \"checkpoint_model\": \"MODEL_PLACEHOLDER_M50\",\n    \"use_last_planner_model\": false,\n    \"is_sync\": false,\n    \"max_user_requests\": 10,\n    \"include_last_user_message\": false,\n    \"include_conversation_log\": true,\n    \"include_running_task_snapshots\": true,\n    \"include_subagent_snapshots\": true,\n    \"include_artifact_snapshots\": true,\n    \"retry_config\": {\n        \"max_retries\": 0,\n        \"initial_sleep_duration_ms\": 1000,\n        \"exponential_multiplier\": 2,\n        \"include_error_feedback\": false\n    },\n    \"session_summary_prompt_override\": \"\",\n    \"use_model_reported_token_count\": false\n}"
          }
        }
      },
      "modelProvider": "MODEL_PROVIDER_OPENAI",
      "quotaInfo": {
        "remainingFraction": 1,
        "resetTime": "2026-10-13T11:58:35Z"
      },
      "recommended": true,
      "supportsThinking": true,
      "tagDescription": "GPT-OSS will be removed from Antigravity on November 2, 2026.",
      "tagTitle": "Notice",
      "thinkingBudget": 8192,
      "vertexModelId": "openai/gpt-oss-120b-maas"
    },
    "tab_flash_lite_preview": {
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "maxOutputTokens": 4096,
      "maxTokens": 16384,
      "model": "MODEL_PLACEHOLDER_M19",
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 1
      },
      "requiresLeadInGeneration": true,
      "supportsCumulativeContext": true,
      "supportsEstimateTokenCounter": true,
      "toolFormatterType": "TOOL_FORMATTER_TYPE_XML"
    },
    "tab_jump_flash_lite_preview": {
      "addCursorToFindReplaceTarget": true,
      "apiProvider": "API_PROVIDER_GOOGLE_GEMINI",
      "maxOutputTokens": 4096,
      "maxTokens": 16384,
      "model": "MODEL_PLACEHOLDER_M28",
      "modelProvider": "MODEL_PROVIDER_GOOGLE",
      "quotaInfo": {
        "remainingFraction": 1
      },
      "requiresLeadInGeneration": true,
      "requiresNoXmlToolExamples": true,
      "supportsCumulativeContext": true,
      "supportsEstimateTokenCounter": true,
      "tabJumpPrintLineRange": true,
      "toolFormatterType": "TOOL_FORMATTER_TYPE_XML"
    }
  },
  "mqueryModelIds": [
    "gemini-3.5-flash-lite"
  ],
  "tabModelIds": [
    "chat_20706",
    "chat_23310"
  ],
  "tieredModelIds": {
    "flash": [
      "gemini-3.8-flash-tiered"
    ],
    "flashLite": [
      "gemini-3.5-flash-lite"
    ],
    "pro": [
      "gemini-3.8-flash-tiered"
    ]
  },
  "webSearchModelIds": [
    "gemini-3.5-flash-lite"
  ],
  "deprecatedModelIds": {
    "gemini-3.1-pro-high": "gemini-pro-agent"
  }
}
